import React, { CSSProperties } from 'react';
import classNames from 'classnames';
import Icon from '../../../Icon';
import { ITableColumn } from 'src/components/Table/types';
import './TableHeader.scss';

interface TableSort {
  accessor: string;
  direction: string;
}

interface TableHeaderProps {
  columns: ITableColumn[];
  sort: TableSort;
  onSort: (next: TableSort) => void;
  stickyHeader: boolean;
  headerTop?: number | string;
}

const TableHeader = ({
  columns,
  sort,
  onSort,
  stickyHeader,
  headerTop,
}: TableHeaderProps) => {
  const headerStyle = (style: CSSProperties): CSSProperties => {
    return {
      ...style,
      marginTop: headerTop ?? style.top ?? undefined,
    };
  };

  const toggleDirection = (accessor: string) => {
    onSort({
      accessor,
      direction: sort.direction === 'ascending' ? 'descending' : 'ascending',
    });
  };

  return (
    <div role="rowgroup" className="juniper-datatable-rowgroup">
      <div role="row" className="juniper-datatable-row">
        {columns.map((c: ITableColumn, i: number) => (
          <div
            role="columnheader"
            key={`table-header-${i}`}
            className={classNames('juniper-datatable-headercell', {
              'juniper-datatable-center': c.center,
              'juniper-datatable-sticky-head': stickyHeader,
              'juniper-datatable-sticky-col': c.sticky,
            })}
            style={headerStyle(c.style ?? {})}
          >
            {c.sortable ? (
              <button
                className="juniper-datatable-sort"
                onClick={() => toggleDirection(c.accessor)}
              >
                {c.label}
                {c.accessor === sort.accessor && (
                  <Icon
                    glyph={
                      sort.direction === 'ascending' ? 'caret-up' : 'caret-down'
                    }
                    weight="solid"
                  />
                )}
              </button>
            ) : (
              c.label
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TableHeader;